import { Store } from 'redux';

const holder: { store?: Store } = {};

export const saveStore = (store: Store): void => {
  holder.store = store;
};
export const getStore = (): Store | undefined => holder.store;
